import i18next from '~/utils/i18n';

const toKey = (source: string) => {
  const words = source
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const slug = words.map((word, index) => (index === 0 ? word[0].toLowerCase() + word.slice(1) : word[0].toUpperCase() + word.slice(1))).join('');
  let hash = 2166136261;
  for (let index = 0; index < source.length; index++) hash = Math.imul(hash ^ source.charCodeAt(index), 16777619);
  return `settings.accountUi.${(slug || 'punctuation').slice(0, 56)}_${(hash >>> 0).toString(36)}`;
};

export const accountT = (source: string, options?: Record<string, unknown>) => i18next.t(toKey(source), { defaultValue: source, ...options });
